// Default durations
export const STANDARD_DURATION = 7000
export const IMPORTANT_DURATION = Infinity
